import * as ActionTypes from '../Timetable';

export function clearTimetable() {
    return {type: ActionTypes.CLEAR_TIME_TABLE, section: 'timetable'};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Timetable.js